import Button from 'components/commercetools-ui/atoms/button';
import React from 'react';

interface RatingBannerProps {
  title?: string;
  body?: string;
  cta?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

const RatingBanner: React.FC<RatingBannerProps> = ({ title, body, cta, className = '' }) => {
  return (
    <div
      className={`flex w-full flex-col gap-24 bg-bg-secondary p-32 md:justify-start lg:flex-row lg:justify-between ${className}`}
      data-testid="rating-banner"
    >
      <div className="flex flex-col gap-8 lg:flex-1">
        {title && <p className="body-text-medium font-medium">{title}</p>}
        {body && <p className="body-text-small text-text-primary">{body}</p>}
      </div>
      {cta && (
        <Button variant="primary" onClick={cta.onClick} data-testid="rating-banner-cta" className="max-h-50 max-w-fit">
          {cta.label}
        </Button>
      )}
    </div>
  );
};

export default RatingBanner;
